<div class="flex items-center justify-center min-h-screen bg-gray-100">
  <div>
    <h1 class="text-2xl font-bold text-center mb-6 text-gray-800">
     {{'LOGOUT_SUCCESSFUL' | translate }}
    </h1>
    <p>{{'LOGOUT_SUCCESSFULLY' | translate }} </p>    
  </div>
</div>